/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {GetServerSidePropsContext} from 'next';
import {getPageData} from '../[[...slug]]/index.page';
import LoginPasswordlessTemplate from '@wearesection/bandai-react-components/organisms/LoginPasswordless';
import {Box} from '@mui/material';
import {usePageSetting} from '~/providers/page-context.provider';
import authorApi from '../api/services/author-api';
import {useRouter} from 'next/router';
import {getGloablByType} from '~/utils/global-operations';
import {GLOBAL_TYPE} from '~/constants/content-map-type';
import {handleConvertToLocaleContentful} from '~/utils';
import {IPropsLogin} from '../login/index.page';
import {BlockRenderer} from '~/components/renderer/block-renderer';

const LoginPasswordless = (props: IPropsLogin) => {
  const {imageLogin, seo} = props;
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const [successful, setSuccessful] = useState(false);
  const [warning, setWarning] = useState('');
  const router = useRouter();
  const {query, locale} = router;

  useEffect(() => {
    if (`${query?.isValid}` === 'false') {
      setWarning(dataTranslation['estore-passwordless-link-expired-warning']);
    }
    if (['tc', 'ko-kr'].includes(`${locale}`.toLowerCase())) {
      router.push('/login');
    }
  }, [query, locale]);

  const args = {
    sendButton: {
      variant: 'primaryDark',
      label: dataTranslation['estore-passwordless-send-link-button'],
      disabled: true,
      fullWidth: true,
      handler: async (_undefined: any, _props: any, formData: any) => {
        handleSendEmail(formData.email);
      },
    },
    ...imageLogin,
    alt: 'image',
    title: dataTranslation['estore-passwordless-title'] ?? '',
    description: dataTranslation['estore-passwordless-description'] ?? '',
    locale: 'ko-kr',
    emailField: {
      label: dataTranslation['estore-login-email-field-label'],
      helperText: dataTranslation['estore-login-email-field-helper-text'],
      emptyField: dataTranslation['estore-login-email-field-empty'],
      hiddenLabel: true,
      success: false,
      iconPosEnd: true,
    },
    toastMessage: dataTranslation['estore-passwordless-sent-email-successful-toast-message'],
  };

  const handleSendEmail = (email: string) => {
    const data = {
      email,
      isKeepLogin: false,
    };
    authorApi
      .loginPasswordless(data)
      .then(response => {
        if (response.status !== 200) {
          throw response;
        }
        setSuccessful(true);
        setWarning('');
      })
      .catch(() => {
        setSuccessful(true);
        setWarning('');
        // setWarning(dataTranslation['estore-login-email-does-not-exist'] ?? 'Email does not exist');
      });
  };

  const SeoStandard = seo?.['login-passwordless']
    ? {
        __typename: 'SeoStandard',
        ...seo['login-passwordless'],
      }
    : null;

  return (
    <Box
      sx={{
        paddingBottom: '80px',
      }}
    >
      {SeoStandard && <BlockRenderer block={[SeoStandard]} />}
      <LoginPasswordlessTemplate
        {...args}
        successful={successful}
        warning={warning}
        setEmptyWarning={() => {
          setWarning('');
        }}
      />
    </Box>
  );
};

export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);
  const promises: [
    ReturnType<typeof getPageData>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>
  ] = [
    getPageData({slug: 'store', preview}, ctx),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.ImageLogin),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.SEO),
  ];
  const [pageData, imageLogin, seo] = await Promise.all(promises);
  const {data} = pageData;

  return {
    props: {
      data,
      imageLogin,
      seo,
    },
    revalidate: 60 * 5,
  };
};
export default LoginPasswordless;
